module.exports = __webpack_public_path__ + "img/img2.b72ade6f.jpg";